class BrowserNavigationService {
    public navigateToChat(roomId?: string): void {
        const currentPath = window.location.pathname;
        const targetPath = roomId ? `/chat?room=${roomId}` : '/chat';

        if (currentPath === '/chat' && !roomId) {
            return;
        }

        window.history.pushState({ roomId }, '', targetPath);

        window.dispatchEvent(new PopStateEvent('popstate', {
            state: { roomId, navigatedFrom: 'notification' }
        }));

        console.log('Navigated to:', targetPath);
    }

    public getCurrentPath(): string {
        return window.location.pathname;
    }

    public isOnChatPage(): boolean {
        return window.location.pathname === '/chat';
    }
}

export const browserNavigationService = new BrowserNavigationService();